import MyHeader from '../../components/header';
import MyFooter from '../../components/footer';
import { auth, db } from '../../firebase';

import Spacer from '../../components/spacer';
import { Form, Link, useLoaderData, useNavigate } from 'react-router-dom';
import l from './a.module.scss';
import { useEffect } from 'react';
import { getValFrmDict, sdgs, slug } from '../../../k4dAdmin/data';

import { truncateForLink } from '../../data';

export default function ContactUs() {
  return (
    <>
      <MyHeader />
      <div className={l.whole0}>
        <div className={l.whole}>
          <div className={l.co}>
            <Spacer />
            <h1>Contact Us</h1>

            <p>
              Email <a href="mailto:24593184@nwu.ac.za">24593184@nwu.ac.za</a>
            </p>
          </div>
          <MyFooter />
        </div>
      </div>
    </>
  );
}
